/* eslint-disable react/display-name */
import createClass from 'create-react-class'
import React from 'react'
import i18n from 'live/services/i18n'
import FormBase from 'live/components/extensions/ui/form'
import FormGroup from 'live/components/forms/ui/form-group'
import consts from './const'
import { getTypes, get, getProps } from './types/decorator'
import Select from 'live/components/forms/ui/select'
import './types/index'
import globalNotification from 'live/services/global-notification'
import confirmation from 'live/services/global-confirmation'

const ValidationMixin = require('live/components/forms/mixins/validation-mixin')

const ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: 'plugin-pipes2state',
    active: true,
    config: {
        query: '=> "A" as key, "B" as value at the end',
        span: 'today',
        type: consts.allTypes[0],
        outputParams: consts.defaultOutputParams[consts.allTypes[0]],
        realtimeQuerySpan: 'none',
        realtimeQuery: '=> "A" as key, random(0,10):round as value every minute',
        key: 'key',
        value: 'value',
        cron: 'cron("* 1 * * *")',
        ...getProps('config')
    },
    fullQualifier: null,
    qualifier: null,
    status: {}
})

export default createClass({
    displayName: 'Form',
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    query: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('query must not be empty')
                    },
                    span: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('span must not be empty')
                    },
                    key: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('event key of lookupMacro must not be empty')
                    },
                    value: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('event value of lookupMacro must not be empty')
                    },
                    __validation_dynamic_cron: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('cron must not be empty')
                    }
                }
            }
        }
    },
    setValidations(type) {
        const shouldRequireLookup = type !== 'record'

        this.validations = {
            properties: {
                config: {
                    properties: {
                        query: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('query must not be empty AAA')
                        },
                        span: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('span must not be empty BBBB')
                        },
                        __validation_dynamic_cron: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('cron must not be empty CCCC')
                        }
                    }
                }
            }
        }
    },
    _onAfterFetch: function () {
        // add validation-only config properties, which will be removed before saving.
        // handleValidation is used because it adds the properties to the config object while also
        // setting their validation state, avoiding validation error messages when saving unmodified
        // properties on existing instances
        const object = this.state.object
        const config = object.config

        const getProperty = (type, name) => {
            if (config[`${type}Params`] && config[`${type}Params`][name]) {
                return config[`${type}Params`][name]
            }
            if (config.outputParams[name]) {
                return config.outputParams[name]
            }

            return defaultOutputParams[type][name]
        }

        const properties = getTypes().reduce((s, { type, properties }) => ({ ...s, [type]: properties }), {})

        for (const type in properties) {
            properties[type].forEach(p =>
                this.handleValidation({
                    target: {
                        name: `config.__validation_${type}_${p}`,
                        value: getProperty(type, p)
                    }
                })
            )
        }
    },
    onChangeCode: function (name, event) {
        const object = this.state.object
        const config = object.config
        const value = typeof event === 'object' ? event.target.value : event

        config[name] = value
        this.applyObj(object)
        this.handleValidation({ target: { name: `config.${name}`, value } })
    },
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        window.location.href = '#/integrations/'
    },
    renderSwitch: function () {
        const object = this.state.object
        const config = object.config

        const updateValidation = type =>
            (this.validations.properties.config.properties = Object.keys(
                this.validations.properties.config.properties
            ).reduce(
                (obj, key) => ({
                    ...obj,
                    [key]: key.startsWith('__validation_' + type)
                        ? {
                              ...this.validations.properties.config.properties[key],
                              required: true,
                              allowEmpty: false
                          }
                        : key.startsWith('__validation')
                        ? {
                              ...this.validations.properties.config.properties[key],
                              required: false,
                              allowEmpty: true
                          }
                        : this.validations.properties.config.properties[key]
                }),
                {}
            ))

        const { Component: Type = () => null } = get(config.type) || {}

        this.setValidations(config.type)

        return (
            <Type
                onChange={this.onChangeCode}
                onChangeCode={this.onChangeCode}
                validationState={updateValidation}
                handleValidation={this.handleValidation}
                errorsFor={this.errorsFor}
                config={this.state.object.config}
            />
        )
    },
    onChangeOutput: function (selected) {
        const object = this.state.object
        const config = object.config

        if (config.type) config[`${config.type}Params`] = config.outputParams

        config.type = selected

        if (!config[`${selected}Params`]) config.outputParams = consts.defaultOutputParams[selected]
        else config.outputParams = config[`${selected}Params`]

        this.applyObj({ config: config })
        this.handleValidation({ target: { name: 'config.type', value: selected } })
    },
    onChangeOutputParameter: function (name, event, isValidated, isIndexed, index) {
        const object = this.state.object
        const config = object.config
        const type = config.type
        const value = typeof event === 'object' ? event.target.value : event

        if (isIndexed) config.outputParams[name][index] = value
        else config.outputParams[name] = value

        this.applyObj(object)

        if (isValidated) this.handleValidation({ target: { name: `config.__validation_${type}_${name}`, value } })
    },
    render: function () {
        const object = this.state.object
        const config = object.config

        return (
            <FormBase self={this}>
                <div className="form-area">
                    <h3>{i18n('Config')}</h3>

                    <div className="form-group">
                        <Select
                            label="Type"
                            value={config.type}
                            options={getTypes().map(({ type, label = null }) => ({
                                value: type,
                                label: label || type
                            }))}
                            onChange={this.onChangeOutput}
                            validationState={this.validationState('config.type')}
                            hasFeedback
                            help={this.errorsFor('config.type')}
                        />

                        <span className="help-block">
                            <p>{i18n('Choose the best fit for each usage.')}</p>

                            <p>
                                <strong>Realtime</strong>: {i18n('REALTIME_TYPE_DESCRIPTION')} <br />
                                <strong>Historical</strong>: {i18n('HISTORICAL_TYPE_DESCRIPTION')} <br />
                            </p>
                        </span>
                    </div>

                    {this.renderSwitch()}
                    <hr />

                    <button
                        className={'btn btn-primary mb-6'}
                        onClick={() => {
                            confirmation.warn(
                                <>Are you sure you want the rebuild this state?</>,
                                () => {
                                    fetch('/services/plugin-pipes2state/reset/' + object.id, { method: 'post' })
                                    globalNotification.info(i18n('State successfully scheduled for rebuild.'))
                                },
                                {
                                    btnText: i18n('Rebuild')
                                }
                            )
                        }}
                    >
                        {i18n('Rebuild State')}
                    </button>
                    <div className={'mb-15'}>
                        <em className={'text-muted'}>
                            Rebuilding the state will reset the internal cache structures and re-run all historical and
                            realtime queries to re-populate internal caches.
                        </em>
                    </div>
                    <button
                        className={'btn btn-primary mb-6'}
                        onClick={() => {
                            confirmation.warn(
                                <>Are you sure you want to manual override and save this state to disk?</>,
                                () => {
                                    fetch('/services/plugin-pipes2state/save-to-disk/' + object.id, { method: 'post' })
                                    globalNotification.info(i18n('State successfully scheduled for saving to disk.'))
                                },
                                {
                                    btnText: i18n('Save to disk')
                                }
                            )
                        }}
                    >
                        {i18n('Force save to disk')}
                    </button>
                    <div className={'mb-15'}>
                        <em className={'text-muted'}>
                            Manually saving to disk has no side effects. It is a manual override for some edge cases and is recommended after Rebuilding the state.
                        </em>
                    </div>
                    <hr />
                </div>
            </FormBase>
        )
    }
})
